export default __webpack_public_path__ + "static/media/Slide17.1e5468f6.JPG";